// Link público de assinatura do contrato do cliente (pedido 2026-09-11) —
// telas em components/contract-signing-wizard.tsx. Rota pública: ver
// isPublicStaticRoute em __root.tsx ("/contrato/assinar/").
import { createFileRoute } from "@tanstack/react-router";
import { ContractSigningWizard } from "@/components/contract-signing-wizard";
import { gpsDriveContractSigningService } from "@/services/gpsdrive-contract-signing.service";

export const Route = createFileRoute("/contrato/assinar/$token")({
  head: () => ({ meta: [{ title: "Assinatura de Contrato — GPS Drive" }] }),
  component: ContractSigningPage,
});

function ContractSigningPage() {
  const { token } = Route.useParams();
  return <ContractSigningWizard token={token} service={gpsDriveContractSigningService} />;
}
